<template>
  <template v-if="deselectionValues?.length">
    <div :class="drawer ? 'pills-container-drawer' : 'pills-container'">
      <button
        v-for="(value, index) in deselectionValues"
        :key="index"
        @click="onDeselect(value)"
      >
        <span class="value-text">
          {{ value?.label || value.value }}
        </span>
        <span :class="brand === 'mcom' ? 'close-large' : 'close'" />
      </button>
    </div>
  </template>
</template>

<script setup>
import { brand } from 'config';
import useDeselectionPills from '../../composables/useDeselectionPills';

const props = defineProps({
  drawer: {
    type: Boolean,
    default: false,
  },
  facet: {
    type: Object,
    default: null,
  },
});

const { deselectionValues, onDeselect } = useDeselectionPills(props);
</script>
